import { fvDate } from '@fv/dates'

import type { OppListingStatus } from '@/features/opportunities/types'

export function getStartDateForStatus(status: OppListingStatus) {
  const daysAgo = status === 'awarded' || status === 'confirmed' ? 60 : 30
  return fvDate().subtract(daysAgo, 'day').format('YYYY-MM-DD')
}
